import { type Module } from "vuex";
import type { DefaultApi } from "@/api";
import type { State as RootState } from "@/stores";

export interface State {}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getDefault(): Promise<string | null> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getEvaluationEmailSettingDefault();
      return response.data.opening_text;
    },
    async putDefault({}, openingText: string | null): Promise<string | null> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.putEvaluationEmailSettingDefault({
        opening_text: openingText,
      });
      return response.data.opening_text;
    },
    async getForPosition({}, positionId: number): Promise<string | null> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getEvaluationEmailSetting(positionId);
      return response.data.opening_text;
    },
    async putForPosition(
      {},
      {
        positionId,
        openingText,
      }: { positionId: number; openingText: string | null },
    ): Promise<string | null> {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.putEvaluationEmailSetting(positionId, {
        opening_text: openingText,
      });
      return response.data.opening_text;
    },
  },
};
